import { CountryCode, CountryCodeFallback } from 'models/enums/CountryCode';

type CanCodes = CountryCode | CountryCodeFallback;

export function normalizeCountryCode(countryCode: string): CountryCode | string {
  if (!countryCode) return undefined;
  const ccToUpper = countryCode?.toUpperCase();
  const canCodes: CanCodes[] = [CountryCode.CAN, CountryCodeFallback.CA, CountryCodeFallback.CANADA];

  if (canCodes.includes(ccToUpper as CanCodes)) {
    return CountryCode.CAN;
  }

  return ccToUpper;
}
